import { render } from "./ProjectCompleted.vue?vue&type=template&id=7f6ab2e2"
import script from "./ProjectCompleted.vue?vue&type=script&lang=js"
export * from "./ProjectCompleted.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\USER\\Desktop\\New folder\\Lynkme360\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__